// extracted by mini-css-extract-plugin
module.exports = {"OAuthRedirectURIs__sla-tier-label__5d6fD":"OAuthRedirectURIs__sla-tier-label__5d6fD","OAuthRedirectURIs__tooltip-icon__1wnHg":"OAuthRedirectURIs__tooltip-icon__1wnHg"};